module.exports = __webpack_public_path__ + "static/media/epay_row.5f977cce.png";